function formatMoney(cents, format = window.moneyFormat || "${{amount}}") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split(".");
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}


window.formatMoney = formatMoney;

(function () {
  const selectors = {
    oneTimePurchase: ".appstle_one_time_text",
    subscription: ".appstle_subscribe_save_text",
    payAsYouGoPlan: ".payAsYouGoPlansDropdownWrapper",
    freeRewardBanner: ".product-free-reward",
    radioButtonsWrapper: ".appstleRadioSellingPlanWrapper",
    subscribeOption: ".appstle_subscribe_option",
    insideSubscriptionElements: "[data-inside-subscription='true']",
    iconWithTextPopupTrigger: ".product_icon-with-text-popup",
    iconWithTextPopup: ".icon-with-text-popup",
    iconWithTextPopupClose: ".popup_close",
    price: ".product-form__submit [data-cart-price]",
    comparePrice: ".product-form__submit [data-cart-compare-price]",
    completeSavePercent: "[complete-save-percent]",
  };

  // Keep checking if elements appear in the DOM
  const checkIfElementsExist = setInterval(() => {
    if (
      document.querySelector(selectors.oneTimePurchase) &&
      document.querySelector(selectors.subscription)
    ) {
      clearInterval(checkIfElementsExist);
      init();
    }
  }, 100);

  function init() {
    const oneTimePurchase = document.querySelector(selectors.oneTimePurchase);
    const subscription = document.querySelector(selectors.subscription);
    const payAsYouGoPlan = document.querySelector(selectors.payAsYouGoPlan);
    const elementsInsideSubscription = document.querySelectorAll(
      selectors.insideSubscriptionElements
    );

    const alreadyHaveElements = payAsYouGoPlan.querySelectorAll(
      "[data-inside-subscription]"
    ).length;

    if (!alreadyHaveElements) {
      elementsInsideSubscription.forEach((element) => {
        const clonedElement = element.cloneNode(true);
        clonedElement.dataset.insideSubscription = false;
        payAsYouGoPlan.appendChild(clonedElement);
      });

      // Handle popup open and close events
      const openPopup = payAsYouGoPlan.querySelectorAll(
        selectors.iconWithTextPopupTrigger
      );
      const popupContainer = document.querySelectorAll(
        selectors.iconWithTextPopup
      );
      const closePopup = document.querySelectorAll(
        selectors.iconWithTextPopupClose
      );

      openPopup.forEach((item) =>
        item.addEventListener("click", () => {
          popupContainer.forEach((container) => {
            container.classList.add("active");
          });
        })
      );

      closePopup.forEach((item) =>
        item.addEventListener("click", () => {
          popupContainer.forEach((container) => {
            container.classList.remove("active");
          });
        })
      );
    }

    // Remove "Ships Every" from subscription widget
    const radioButtonsWrapper = document.querySelector(
      selectors.radioButtonsWrapper
    );
    if (radioButtonsWrapper) {
      radioButtonsWrapper
        .querySelectorAll(".sellingplan")
        .forEach(
          (item) =>
            (item.innerHTML = item.innerHTML.replace("Ships Every ", ""))
        );
    }

    // Set prices based on selected variant and selling plan
    setTimeout(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const selectedSellingPlanId = urlParams.get("selling_plan");
      const selectedVariantId = urlParams.get("variant");

      const variantJson = JSON.parse(
        document.querySelector("variant-radios script[type='application/json']")
          .innerText || "[]"
      );
      const selectedVariant = variantJson.find(
        (variant) => variant.id == parseFloat(selectedVariantId)
      );

      if (!selectedSellingPlanId) {
        updatePrices(selectedVariant);
        return;
      }

      const selectedSellingPlan = selectedVariant.selling_plan_allocations.find(
        (allocation) => allocation.selling_plan_id == selectedSellingPlanId
      );

      if (selectedSellingPlan) {
        updatePrices(selectedVariant, selectedSellingPlan);
      }
    }, 300);
  }

  function updatePrices(variant, selectedSellingPlan = null) {
    if (!variant) return;

    const priceElement = document.querySelector(selectors.price);
    const comparePriceElement = document.querySelector(selectors.comparePrice);

    if (priceElement) {
      priceElement.innerHTML = window.formatMoney(
        selectedSellingPlan ? selectedSellingPlan.price : variant.price
      );
    }

    let comparePrice = selectedSellingPlan
      ? selectedSellingPlan.compare_at_price
      : variant.compare_at_price;

    if (comparePriceElement) {
      comparePriceElement.innerHTML = comparePrice
        ? window.formatMoney(comparePrice)
        : "";
    }

    // if (document.querySelectorAll(selectors.completeSavePercent).length > 0) {
    //   const savePercent = selectedSellingPlan
    //     ? Math.round(
    //         ((comparePrice - selectedSellingPlan.price) / comparePrice) * 100
    //       )
    //     : Math.round(
    //         ((comparePrice - variant.price) / comparePrice) * 100
    //       );

    //   document
    //     .querySelectorAll(selectors.completeSavePercent)
    //     .forEach((item) => {
    //       item.parentElement.classList.toggle("hidden", savePercent <= 0);
    //       item.innerHTML = savePercent + "%";
    //     });
    // }
    if (document.querySelectorAll(selectors.completeSavePercent).length > 0) {
  const saveAmount = selectedSellingPlan
    ? comparePrice - selectedSellingPlan.price
    : comparePrice - variant.price;

  document
    .querySelectorAll(selectors.completeSavePercent)
    .forEach((item) => {
      item.parentElement.classList.toggle("hidden", saveAmount <= 0);
      item.innerHTML = saveAmount > 0 ? saveAmount.toFixed(2) : "0.00";
    });
}

  }

  document.addEventListener(
    "AppstleSubscription:SubscriptionWidget:SellingPlanRemoved",
    () => setTimeout(init, 0)
  );

  document.addEventListener(
    "AppstleSubscription:SubscriptionWidget:SellingPlanSelected",
    () => setTimeout(init, 0)
  );

  document.addEventListener(
    "AppstleSubscription:SubscriptionWidget:widgetInitialised",
    function () {
      document.addEventListener("variant:change", (e) => {
        const variant = e.detail.variant;
        const prefferedSellingPlans = JSON.parse(
          document.querySelector("#PreferredSellingPlans").innerText
        );
        const prefferedSellingPlan = prefferedSellingPlans[variant.id];

        if (
          document.querySelectorAll(".appstle-radio-input-wrapper").length > 0
        ) {
          const appstleInputWrapper = Array.from(
            document.querySelectorAll(".appstle-radio-input-wrapper")
          ).find((itm) => itm.innerText.includes(prefferedSellingPlan));

          const labelFor = appstleInputWrapper.querySelector("input").id;

          setTimeout(() => {
            document.querySelector(`label[for="${labelFor}"]`).click();
          }, 0);
        }
      });
    }
  );

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const section = document.querySelector(
      `[data-section="${event.data.sectionId}"]`
    );

    const variant = event.data.variant;
    const params = new URLSearchParams(window.location.search);
    const sellingPlanId = params.get("selling_plan");

    if (sellingPlanId) {
      const selectedSellingPlan = variant.selling_plan_allocations.find(
        (sp) => sp.selling_plan_id == sellingPlanId
      );

      section.querySelector(selectors.price).innerHTML = window.formatMoney(
        selectedSellingPlan.price
      );

      if (variant.compare_at_price) {
        section.querySelector(selectors.comparePrice).innerHTML =
          window.formatMoney(variant.compare_at_price);
      } else {
        section.querySelector(selectors.comparePrice).innerHTML =
          window.formatMoney(selectedSellingPlan.compare_at_price);
      }
      return;
    }

    if (document.querySelectorAll(selectors.completeSavePercent).length > 0) {
      const x = Math.round(
        ((variant.compare_at_price - variant.price) /
          variant.compare_at_price) *
          100
      );

      document
        .querySelectorAll(selectors.completeSavePercent)
        .forEach((item) => {
          item.parentElement.classList.toggle("hidden", x <= 0);
          item.innerHTML = x + "%";
        });
    }

    section.querySelector(selectors.price).innerHTML = window.formatMoney(variant.price);

    if (variant.compare_at_price) {
      section.querySelector(selectors.comparePrice).innerHTML =
        window.formatMoney(variant.compare_at_price);
    } else {
      section.querySelector(selectors.comparePrice).innerHTML = "";
    }
  });
})();


(function () {
  const selectors = {
    thumb: ".thumbnail",
    thumbList: ".thumbnail-list",
    mediaGallery: "media-gallery",
    thumbListItem: ".thumbnail-list__item",
    productGalleryButtons: ".slider-button--custom",
  };

  const productGalleryButtons = document.querySelectorAll(
    selectors.productGalleryButtons
  );

  if (productGalleryButtons.length == 0) return;

  productGalleryButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const buttonAction = button.getAttribute("name");

      const thumbsList = button
        .closest(selectors.mediaGallery)
        .querySelector(selectors.thumbList);

      const currentThumb = thumbsList.querySelector(
        `${selectors.thumb}[aria-current="true"]`
      );

      if (buttonAction == "next") {
        currentThumb.parentElement.nextElementSibling
          .querySelector("button")
          .click();
      }

      if (buttonAction == "previous") {
        currentThumb.parentElement.previousElementSibling
          .querySelector("button")
          .click();
      }
    });
  });
})();
